<template>
  <div class="cursor-pointer" :class="{'column is-half-widescreen is-half-desktop is-half-tablet is-full-mobile': !linkStyles && isHalf,
                'column is-one-third-widescreen is-one-third-desktop is-half-tablet is-full-mobile': !linkStyles && !isHalf,
                'column card-container': linkStyles}">
    <router-link :to="linkedPath" :event="disableClick ? '' : 'click'" @click.native="emitClick">
      <div class="project-card" :class="{'project-card-link' : linkStyles}">
        <div class="image" :class="{'image-link' : linkStyles}" :style="displayImage"></div>
        <div class="details">
          <div class="title">{{linkedProject.title}}</div>
          <div class="description">
            <html-view :content="description"></html-view>
            <div class="fade"></div>
          </div>
        </div>
        <div class="footer">
          <div class="user" @click.prevent="goToUser(project.user.userName)">
            <user-avatar v-if="isVisible" :user="linkedProject.user"></user-avatar>
            <span class="username">{{formattedUser}}
              <span v-if="linkedProject.user.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span>
            </span>
          </div>
          <div class="metrics" v-if="!linkStyles">
            <div v-if="!showFollows" class="views is-flex">
              <span class="icon"><i class="fal fa-eye" aria-hidden="true"></i></span>
              <span class="count">{{linkedProject.metadata.views}}</span>
            </div>
            <div v-if="showFollows" class="follows is-flex">
              <span class="icon"><i class="fal fa-users" aria-hidden="true"></i></span>
              <span class="count">{{linkedProject.metadata.subscribers}}</span>
            </div>
            <div class="likes is-flex" @click.prevent="canLike" :class="{liked: hasLiked}">
              <span class="icon"><i class="fal fa-thumbs-up" aria-hidden="true"></i></span>
              <span class="count">{{linkedProject.metadata.likes}}</span>
            </div>
          </div>
        </div>
        <div v-if="tag" class="tag" :class="tagClass">{{tag}}</div>
        <visibility-flags :project="linkedProject"></visibility-flags>
      </div>
    </router-link>
  </div>
</template>

<script>
import base from '../mixins/base'
import imageProxy from '@/libs/image-proxy'
import breakpoints from '@/libs/breakpoints'
import visibility from '@/mixins/visibility'
import HtmlView from '@/components/Controls/HTMLView'

export default {
  props: ['linkedProject', 'showFollows', 'linkStyles', 'disableClick', 'isHalf', 'recommendationSource', 'recommendationType'],
  mixins: [base, visibility],
  components: {
    HtmlView
  },
  computed: {
    tag: function () {
      if (this.linkedProject && this.linkedProject.tags && this.linkedProject.tags.length > 0) {
        return (this.linkedProject.tags[0].name)
      }
    },
    tagClass: function () {
      const tag = this.tag
      if (tag) {
        return tag.replace('&', 'and').replace(/\s+/g, '-').replace('/', '-').replace(/^([0-9])/g, 't-$1').toLowerCase()
      }
    },
    displayImage: function () {
      const style = {}

      if (this.linkedProject && this.linkedProject.image) {
        style.backgroundImage = `url('${imageProxy.project(this.linkedProject.image)}')`
      }

      return style
    },
    formattedUser: function () {
      let username = this.linkedProject.user.userName

      if (username.length > 10 && breakpoints.isBetween(1100, 1280)) {
        username = `${username.substring(0, 9)}...`
      }

      return username
    },
    linkedPath: function () {
      return `/project/${this.linkedProject.slug}`
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .project-card {
    width: 100%;
    height: 403px;
    background: white;
    position: relative;
    cursor: pointer;
    color: #4a4a4a;
    box-shadow:0 0 11px rgba(33, 33, 33, .2);
    transition:0.4s;

    @include mobile {
      display: flex;
      height: 200px;
      flex-wrap: wrap;
      padding: 0.5rem 0.5rem 2rem 0.5rem;
      max-width: 450px;
      margin:0 auto;
    }

    .image {
      height: 55%;
      padding:0;
      background-color: whitesmoke;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;

      @include mobile {
        flex-basis: 50%;
        height: 100%;
      }
    }
    .image-link{
      height:35%;
      @include tablet-only{
      height: 50%;
      }
      @include mobile {
        height: auto;
      }
    }

    .details {
      position: relative;
      height: 8.9rem;
      overflow: hidden;
      padding: 0.45rem 0.75rem;
      @include mobile {
        flex-basis: 50%;
        padding-left: 0.65rem;
        height: 10rem;
      }

      .fade {
        position: absolute;
        height: 1.6rem;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to right, rgba(255,255,255,0.001), rgba(255,255,255,0.8));
      }
    }

    .title {
      font-size: 1.1rem;
      font-weight: 700;
      margin: 0.4rem 0 0.4rem 0;
      line-height: 1.5rem;
      width: 100%;
      overflow: hidden;

      @include mobile {
        margin-top: 0.5rem;
        font-size: 1rem;
        line-height: 1.3rem;
      }
    }

    .description {
      @include mobile {
        font-size: 0.8rem;
      }
    }

    .footer {
      margin-top: 0.2rem;
      background: none;
      padding: 0.40rem 0.75rem;
      width: 100%;

      display: flex;
      justify-content: space-between;
      align-items: center;

      @include mobile {
        flex-basis: 100%;
        margin-top: 0.15rem;
        padding: 0.10rem;
      }

      .user {
        display: flex;
        font-size:0.85rem;
        align-items: center;

        .avatar {
          height: 1.5rem;
          width: 1.5rem;
          margin-right: .4rem;

          img {
            width: 100%;
            height: 100%;
            background: white;
            border-radius: 50%;
            box-shadow: 0px 0.5px 5px rgba(0,0,0,.5);
          }
        }
      }

      .metrics {
        display: flex;
        justify-content: flex-end;
        font-size:0.9rem;

        .views, .follows {
          margin-right: 0.5rem;
        }
      }
    }

    .tag {
      color: white;
      text-transform: capitalize;
      position: absolute;
      top: 1.2rem;
      padding: 0 1.2rem;
      font-weight: bold;
      font-size: 0.8rem;
      border-radius: 0;
      @include mobile {
        font-size: 0.72rem;
      }
    }

    @include hover-cards-effect
  }

  .project-card-link {
    height: 275px;
    @include tablet-only {
      height: 360px;
    }
    @include mobile {
      height: 200px;
    }
    .title{
      font-size: 0.9rem;
      line-height: 1rem
    }
    .description {
      font-size: 0.8rem;
    }
    .footer {
       margin-top: 0.01rem;
      @include mobile {
        margin-top: 0.2rem;
      }
    }
    &:hover {
      box-shadow: 0px;
      transform: translateY();
    }
  }

  .user {
    cursor: pointer;
  }

  .card-container {
    width: 100%;
  }

  .liked {
    color: $primary;
  }
</style>
<style lang="scss">
  .project-card .description .markdown-span-override p {
    margin: 0;
  }
</style>
